// src/components/Team.jsx
import '../../styles/components/_team.scss';
import Nati from '../../images/Nati_circle.jpg'
import Nicky from '../../images/nicky_circle.jpg'
import Nico from '../../images/nico_circle.jpg'

const Team = () => {
  const members = [
 
    { name: "Natalia Wensioe", role: "Chief Executive Officer | Founder", photo: Nati },
    { name: "Nicomedes Pommier", role: "Chief Technology Officer | Founder", photo: Nico },
    { name: "Nicole Castro", role: "Chief Operating Officer | Founder", photo: Nicky },

  ];

  return (
    <section className="team">
      <h2>Our founders</h2>
      <div className="team-list">
        {members.map((m, i) => (
          <div key={i} className="member-card">
            <div className="avatar">
              <img src={m.photo} alt={`${m.name}'s profile`} />
            </div>
            <h4>{m.name}</h4>
            <p>{m.role}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
